import { RouterProvider } from '@tanstack/react-router';
import { useEffect } from 'react';
import { router, entry } from '@/routes';

declare global {
  var __onautoRouteInventory:
    | {
        routes: Array<{
          pattern: string;
          path: string;
          title: string;
          page: string;
          standalone: boolean;
          isPublic: boolean;
        }>;
        entry: typeof entry;
      }
    | undefined;
}

export function App() {
  useEffect(() => {
    document.getElementById('root')?.setAttribute('data-app-ready', '1');
    const routes = Object.values(router.routesById)
      .filter((route) => route.id !== '__root__')
      .map((route) => {
        const data = route.options.staticData as {
          title: string;
          page: string;
          standalone: boolean;
          isPublic: boolean;
        };
        return {
          pattern: route.fullPath.replace(/\$([^/]+)/g, '[$1]'),
          path: route.fullPath,
          title: data.title,
          page: data.page,
          standalone: data.standalone,
          isPublic: data.isPublic,
        };
      });
    globalThis.__onautoRouteInventory = { routes, entry };
  }, []);

  return <RouterProvider router={router} />;
}
